<template>
  <div class="page">
      <div class="container">
          <div class="content">
              <h2>跟对的人，读对的书</h2>
              <h3>听万里挑一的人，为你解读万里挑一的书</h3>
              <div class="title-img t2"></div>
              <div class="peoples-pic"><img src="/images/people-pic.png" alt=""></div>
              <ul class="peoples-name">
                  <li>周国平、熊召政、纪连海、张颐武、顾及、李永乐</li>
                  <li>麦家、洪晃、廖一梅、大冰、苏芩、张嘉佳</li>
                  <li>李响、艾弥儿、江南、李柘远</li>
                  <li>孟京辉、喻恩泰、马薇薇</li>
                  <li>曹景行、蒋昌建、张泉灵、张绍刚、刘亚东、马川</li>
                  <li>冯仑、韩国辉、侯小强、李岱</li>
              </ul>
              <ul class="note-list">
                  <li><i></i>每年为你推荐300本精选书目</li>
                  <li><i></i>每年音视频精讲50本书</li>
                  <li><i></i>每周一期40分钟</li>
              </ul>
          </div>
          <div class="info">
              <div class="dec">
                  <div class="my-photo"><img :src="userPic" alt=""></div>
                  <p>{{info.nickName}}</p>
                  <p>送你{{info.money}}红包</p>
                  <p>邀你一起成为朋友圈</p>
                  <p>更有文化的人</p>
                  <p>扫码领取红包</p>
              </div>
              <div class="er-pic" id="qrcode"></div>
          </div>
      </div>
      <div class="btn-bottom">长按可保存海报图片至本地</div>
  </div>
</template>

<script>
import $ from "jquery"
import QRCode from "qrcodejs2"
import wx from "weixin-js-sdk"
import html2canvas from 'html2canvas'

export default {
  name: "share",
  data() {
    return {
      info: {},
      userPic: '',
      isShow: false,
      isConfig: false,
      shareUrl: ''
    };
  },
  computed: {
    cssTest() {
      return {
        background: `#fff url(${this.info.imageUrl}) 100% auto no-repeat`
      };
    }
  },
  created() {
    this.$loading.show({
      el: this.$refs.loading
    });
    let that = this;
    this.shareUrl = `${window.location.protocol}//${window.location.host}/index`
    let isUa = navigator.userAgent.toLowerCase().indexOf("android ") === -1 ? window.location.href : window.location.href
    if(sessionStorage.getItem('tempUrl')){
      isUa = sessionStorage.getItem('tempUrl')
      sessionStorage.clear()
    }
    this.getInfo(isUa)
  },
  methods: {
    getInfo(url) {
      let that = this;
      this.axiosPost("act/toShare", {
        // 通过分享接口获取分享url
        appUrl: window.location.href,
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid')
      }).then(res => {
        this.$loading.hide();
        this.info = res.data.attachment
        this.userPicVal = res.data.attachment.headurl
        this.wechatShare = res.data.attachment.wechatShare
        this.getPic(this.userPicVal)
        this.qrcode()
        this.axiosPost("wechat/jsconfig", {
          // 微信jsapi-config参数获取
          appUrl: url
        }).then(result => {
          this.$loading.hide();
          let infoTotal = result.data.attachment;
          wx.config({
            debug: false,
            appId: infoTotal.appId,
            timestamp: infoTotal.timestamp,
            nonceStr: infoTotal.nonceStr,
            signature: infoTotal.signature,
            jsApiList: [
            "chooseImage",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ"
              // 所有要调用的 API 都要加到这个列表中
            ]
          });
          wx.ready( () => {
            //分享给好友
            wx.onMenuShareAppMessage({
              title: that.wechatShare.title, // 分享标题
              desc: that.wechatShare.desc, // 分享描述
              link: that.wechatShare.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！', // 分享标题
              // desc: '手快有，手慢无！', // 分享描述
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png', // 自定义图标
              type: "link", // 分享类型,music、video或link，不填默认为link
              dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                console.log(window.wechatInfo.title)
                // 用户确认分享后执行的回调函数
              },
              cancel: function() {
                // 用户取消分享后执行的回调函数
              }
            })

            //分享朋友圈
            wx.onMenuShareTimeline({
              title: that.wechatShare.title,
              link: that.wechatShare.link,
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！',
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ',
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png',// 自定义图标
              trigger: function(res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回.
                //alert('click shared');
              },
              success: function(res) {
                //alert('shared success');
                //some thing you should do
              },
              cancel: function(res) {
                //alert('shared cancle');
              },
              fail: function(res) {
                //alert(JSON.stringify(res));
              }
            })
          })
          wx.error(function(res) {
            if(sessionStorage.getItem('tempUrl')){
              return
            }
            sessionStorage.setItem('tempUrl', window.location.href)
            // window.location.reload()
            // if(that.isConfig) return
            // that.isConfig = true
          });
        })
      });
    },
    getPic(val){
      this.axiosPost('v/act/queryBase64',{ // 检查手机号是否已经注册过
        url: val,
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid'),
      }).then((res) => {
        
        this.userPic = res.data.attachment
        console.log(111, res.data.attachment)
        // this.userPic = res.attachment.replace('/r', '')
        var shareContent = document.querySelector('.container');//需要截图的包裹的（原生的）DOM 对象
        var width = shareContent.offsetWidth; //获取dom 宽度
        var height = shareContent.offsetHeight; //获取dom 高度
        var canvas = document.createElement("canvas"); //创建一个canvas节点
        var scale = 2; //定义任意放大倍数 支持小数
        canvas.width = width * scale; //定义canvas 宽度 * 缩放
        canvas.height = height * scale; //定义canvas高度 *缩放
        canvas.getContext("2d").scale(scale, scale); //获取context,设置scale 
        var opts = {
          scale: scale, // 添加的scale 参数
          canvas: canvas, //自定义 canvas
          // logging: true, //日志开关，便于查看html2canvas的内部执行流程
          width: width, //dom 原始宽度
          height: height,
          useCORS: true // 【重要】开启跨域配置
        };

        html2canvas(shareContent, opts).then(function (canvas) {

        var context = canvas.getContext('2d');
        // 【重要】关闭抗锯齿
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        
          let oImg = document.createElement('img')
          oImg.style.cssText = "position: absolute; top: 0;left: 0;width: 100%;opacity: 0;z-index: 99;"
          oImg.src = canvas.toDataURL()
          document.querySelector('.page').appendChild(oImg)

        });
        
      })
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
        width:70,
        height:70,
        text: this.info.wechatShare.link, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel :1 //纠错等级
      });
    },
    shareFn() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    backTo() {
      this.$router.go(-1);
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped>
*{
  font-weight: normal;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  list-style: none;
  outline: none;
  box-sizing: border-box;
}
.page {
  width: 100%;
}
.container {
    width: 100%;
    min-height: 13.34rem;
    background: #77D5D7 url('/images/bg-top.png') no-repeat;
    background-size: 100% auto;
    padding-top: 1.7rem;
    position:absolute;
    top: 0;
    bottom: 0;
}
.content{
    width:6.7rem;
    background:rgba(255,255,255,1);
    border-radius:.3rem;
    margin: 0 auto;
    padding: .24rem;
}
h2{
  font-size:.32rem;
  font-family:STSongti-SC-Black;
  font-weight:900;
  color:rgba(51,51,51,1);
  line-height:.45rem;
  text-align: center;
}
h3{
  font-size:.24rem;
  font-family:STSongti-SC-Black;
  font-weight:900;
  color:rgba(51,51,51,1);
  line-height:.4rem;
  margin: 0rem auto .18rem;
  text-align: center;
}
.title-img{
  height: .5rem;
  margin: 0 auto
}
.t2{
  width: 3rem;
  background: url('/images/t2.png') no-repeat;
  background-size: 100% auto;
  margin-bottom: .1rem;
}
.peoples-pic{
    width: 100%; 
}
.peoples-pic img{
    width: 100%; 
}
.peoples-name{
    width: 100%;
    font-size: .22rem;
    color: #333;
    line-height: .33rem;
    margin-bottom: .2rem;
    text-align: left;
    margin-top: .2rem;
}
.note-list{
    width:100%;
    height:1.4rem;
    border-radius:.1rem;
    border:1px solid rgba(51,51,51,1);
    font-size:.26rem;
    font-family:PingFang-SC-Bold;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:.4rem;
    padding: .1rem .35rem;
    text-align: left;
}
.note-list li{
    font-weight: 900;
}
.note-list li i{
    background :url('/images/circle.png') no-repeat;
    background-size: 100% auto;
    width: .18rem;
    height :.18rem;
    margin-right: .12rem;
    display: block;
    float :left;
    margin-top :.1rem;
}
.info{
    width: 6.7rem;
    height: 2rem;
    margin: 0 auto;
    margin-top: .2rem;
    position: relative;
    overflow hidden
}
.info .dec{
    width: 4.85rem;
    float: left;
}
.info .dec .my-photo{
  width:1.1rem;
  height:1.1rem;
  padding: .05rem;
  border-radius: 50%;
  background: rgba(255,255,255,0.5)
  float: left;
  margin-right: .1rem;
  margin-top:.45rem;
}
.info .dec .my-photo img{
  width 100%
  height 100%
  border-radius 50%
}
.info .dec p{
    font-size: .26rem;
    font-weight: 700;
    line-height: .36rem;
    padding-left:1.2rem;
    text-align: left;
}
.info .dec p:nth-of-type(1){
    font-size: .3rem;
    font-weight: 700;
    line-height: .4rem;
    margin-top:.05rem;
    padding-left:1.2rem;
    text-align: left;
}
.info .er-pic{
    width: 80px;
    height: 80px;
    float:right;
    background:#fff;
    padding: 5px;
    margin-top:.15rem;
}
#qrcode>img{
    width: 100%!important;
    height: 100%!important;
    display: block!important;
}
.btn-bottom{
    width:100%;
    height:.7rem;
    background:#fff;
    font-size: .3rem;
    color: #333;
    text-align: center!important;
    line-height: .7rem;
    position:fixed;
    left: 0;
    bottom: 0;
}
</style>
